import T from 'prop-types';
import React from 'react';
import { Column, Grid } from '@acast/decibel';
import DescriptionField from '../fields/description';
import PositionField from '../fields/position';
import ThumbnailField from '../fields/thumbnail';
import TypeField from '../fields/type';
import VideoUrlField from '../fields/video-url';
import { markerPropType } from '../../../../../../customPropTypes';

const VideoForm = ({ episodeDuration, errors, marker, markers, onUpdateMarker }) => (
  <Grid>
    <Column>
      <ThumbnailField marker={marker} onChange={onUpdateMarker('image')} />
    </Column>
    <Column width="50%">
      <TypeField value={marker.type} onChange={onUpdateMarker('type')} />
    </Column>
    <Column width="50%">
      <PositionField
        marker={marker}
        markers={markers}
        episodeDuration={episodeDuration}
        onChange={onUpdateMarker('start')}
      />
    </Column>
    <Column>
      <VideoUrlField
        error={errors && errors.videoUrl}
        link={marker.body && marker.body.videourl}
        thumbnail={marker.thumbnail && marker.thumbnail.original}
        onChangeUrl={onUpdateMarker('videourl')}
        onChangeThumbnail={onUpdateMarker('image')}
      />
    </Column>
    <Column>
      <DescriptionField value={marker.description} onChange={onUpdateMarker('description')} />
    </Column>
  </Grid>
);

VideoForm.propTypes = {
  episodeDuration: T.number,
  errors: T.shape({
    videoUrl: T.string,
  }),
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType).isRequired,
  onUpdateMarker: T.func.isRequired,
};

VideoForm.defaultProps = {
  episodeDuration: 0,
  errors: null,
};

export default VideoForm;
